<template>
  <div class="">
     <div class="">


   <li v-if="child">
    <router-link :to="{name: 'Child', params: { personId : child.personId } }">

      <Standard with avatar
      <section class="child-compact">
          <div class="avatar">
            <i class="fas fa-user-circle fa-3x child3"></i>
            <Avatar :person="child" size="small"/>
          </div>
          <div class="details">
            <header>
              <h5><strong>{{child.firstName}}</strong> {{child.lastName}}</h5>
              <p>{{child.dob}}</p>
            </header>
          </div>
          <div class="action"> -->
            <font-awesome-icon :icon="['fal', 'chevron-right']"/>
          </div>
      </section>
    </router-link>
  </li>

<!-- new code below -->
<!--
   </div>
      <div class=""> -->

        <!-- <v-list three-line class="pa-0" v-if="child.firstName && child.lastName">
          <v-list-tile avatar v-on:click="saveChangesWarning(1)">
            <v-list-tile-avatar :color="randomColour">
              <img
                v-if="child.photoUrl"
                :src="child.photoUrl"
                :alt="`${childFullName} Avatar`"
              />


              <span v-else class="white--text subheading text-center">{{ childInitials }}</span>

            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>{{ childFullName }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ childVitalDetails }}</v-list-tile-sub-title>

              <v-list-tile-sub-title
                v-on:click="saveChangesWarning(2)"
                :class="[randomColourText]"
                >{{ parentDetails }}</v-list-tile-sub-title
              >
            </v-list-tile-content>
          </v-list-tile> -->

          <!-- <v-layout row justify-center>
            <v-dialog v-model="dialog" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">Are you sure?</v-card-title>
                <v-card-text>Your current edits will not be saved.</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="grey" flat @click="clickCancel">Cancel</v-btn>
                  <v-btn color="orange" flat @click="clickDiscardEdits">Discard Edits</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout> -->

        <!-- </v-list> -->


     </div>
    </div>
</template>

<script>
import colors from 'vuetify/es5/util/colors';
import Avatar from './Avatar';
export default {
  data() {
    return {};
  },

  props: ['personId'],
  computed:{
    child() {
      if(this.personId) {
        return this.$store.getters.children[this.personId];
      }
    },
    childFullName() {
      return `${this.child.firstName} ${this.child.lastName}`;
    },
    childVitalDetails() {
      return `${this.childDobString}`;
    },
    parent() {
    //  if(this.personId) {
        return this.$store.getters.parent; //[this.personId];
    //  }
    },
    colours() {
      let colours = [];
      for (const color in colours) {
        colours.push(color.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase());
      }

      return colours;
    },
    randomNumberBasedOnInitials() {
      const alphabet = [...'abcdefghijklmnopqrstuvwxyz'];
      const firstNameFirstInitial = this.child.firstName[0];
      const index = alphabet.indexOf(firstNameFirstInitial.toLowerCase());

      return index < 0 ? Math.floor(Math.random * 6) + 1 : index;
    },
    randomColour() {
      // const randomNumber = Math.floor(Math.random() * this.colours.length) + 1;
      return this.colours[this.randomNumberBasedOnInitials];
    },
    randomColourText() {
      return `${this.randomColour}--text`;
    },

    avatarBackgroundColour() {
      if (this.child.firstName && this.child.firstName.length > 0) {
        const alphabet = [...'abcdefghijklmnopqrstuvwxyz'];
        let firstNameFirstInitial = this.child.firstName[0];
        let index = alphabet.indexOf(firstNameFirstInitial.toLowerCase());
        if (index > 13) {
          return 'light-green';
        } else {
          return 'teal darken-1';
        }
      } else {
        return 'light-orange';
      }
    },
    childInitials() {
      let firstNameFirstInitial = this.child.firstName[0].toUpperCase();
      let lastNameFirstInitial = this.child.lastName[0].toUpperCase();

      return firstNameFirstInitial + lastNameFirstInitial;
    },
    parentDetails() {
      return `${this.parent.firstName} ${this.parent.lastName}`;
    },
  },

  components : {
    Avatar
  },

  mounted() {},
};
</script>

<style lang="css" scoped>

a {
  text-decoration: none;
  color: inherit
}


.menu {
  margin-top: 50px;
  display: grid;
  grid-row-gap: 3em;

}

li {
  list-style: none;
}


.menu-item {
  list-style: none;
  display: grid;
  grid-template-columns:  1fr 6fr 1fr;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 1.25em;
}

.right-arrow {
  color: lightgrey
  }</style>
